import EventBus from "@plugins/common/service/eventbus";

const StarResourceEventBus = new EventBus();
export default StarResourceEventBus;
